import React, { Component } from 'react';
import { connect } from 'react-redux'
import { openNewAuthChangesModal } from '../../../store/actions/authActions'
import Loader from 'react-loader-spinner';
import RegisterForm from '../forms/RegisterForm';
import LoginForm from '../forms/LoginForm';
class AuthWrapper extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isRegisterSelected: true,
        }
    }
    handleSelection = (sel) => {
        this.setState({
            isRegisterSelected: sel,
        })
    }

    componentDidMount() {
        this.props.openNewAuthChangesModal();
    }
    render() {
        const { modalWidthMedium, modalTitleStyle, auth, isRegisterModal } = this.props;
        const { showLoader, isSignedIn } = auth;
        const { isRegisterSelected } = this.state;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantForm = isRegisterSelected ?<LoginForm isViaModal={true}/> :  <RegisterForm isViaModal={true}/>;
        const relevantComponent = showLoader ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br></br>
                <p style={textStyle}>Processing...</p>
                <br></br>
            </React.Fragment>)
            :
            <React.Fragment>{relevantForm}</React.Fragment>

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <div className="d-flex justify-content-between mb-2">
                        <div className="d-flex flex-row">
                            <div className="align-self-center">
                                <div className="align-self-start">
                                    {/* <h5 style={modalTitleStyle}>login:</h5> */}
                                    {/* <p style={{ fontSize: "10px", color: "GrayText", fontStyle: "italic" }}>Picked coordinates: ({downX}, {downY})</p> */}
                                </div>
                            </div>
                        </div>

                        <div className="d-flex flex-row">
                            <div className="align-self-center">
                                <div className="align-self-end mr-4">
                                    <div className="btn-group btn-group-toggle btn-group-sm" data-toggle="buttons">
                                        <label className="btn btn-outline-dark btn-sm active"><input type="radio" name="options" id="option1" autoComplete="off" onClick={() => this.handleSelection(true)} />
                                            Login
                                        </label>

                                        <label className="btn btn-outline-dark btn-sm"><input type="radio" name="options" id="option2" autoComplete="off" onClick={() => this.handleSelection(false)} />
                                        Register
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* DISPLAY RELEVANT FORM */}
                    {relevantComponent}
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        mut: state.marker,
        sketch: state.sketch,
        auth: state.auth,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        openNewAuthChangesModal: () => dispatch(openNewAuthChangesModal()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AuthWrapper)